import React from 'react';
import { Edit, useEditContext, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Form from './detail/Form';

const Title = () => {
  const { record, isPending } = useEditContext();
  const translate = useTranslate();
  const name = !isPending && record ? record.label : null;
  const action = translate('app.page_title.edit');
  useDocumentTitle(name ? `${name} - ${action}` : action);

  return null;
};

const SchedulerEdit = (props) => {
  return (
    <Edit {...props} title={<Title />}>
      <Form />
    </Edit>
  );
};

export default SchedulerEdit;
